export default __webpack_public_path__ + "static/media/pepsi.dee710ac.png";